import React, { PureComponent } from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { JDImage, JDTouchable, JDShare, JDText } from '@jdreact/jdreact-core-lib';

import { px, pt, share } from '../../common/utils';
class TicketPurchaseNotice extends PureComponent {
    constructor(props) {
        super(props);
    };
    
    render() {
        return (
            <View style={ st.buy_notice }>
                <JDText style={ st.buy_notice_title }>购票须知</JDText>
                <View style={ st.buy_notice_content }>
                    <JDText style={ st.buy_notice_content_txt }>1、请确认场次和时间无误，购买成功后将不可退票，不可改签;</JDText>
                    <JDText style={ st.buy_notice_content_txt }>2、由于影院设备故障、片方原因、政策原因等不可抗力因素，存在少量场次取消的情况，京东电影会接到影院通知后，为用户进行退票退款;</JDText>
                    <JDText style={ st.buy_notice_content_txt }>3、由于影院系统不稳定等因素，导致出票失败的情况京东电影会尽快安排退款;</JDText>
                    <JDText style={ st.buy_notice_content_txt }>4、取票码可以在“我的-电影票”中查看。</JDText>
                </View>
            </View>
        )
    }
}
const st = StyleSheet.create({
    buy_notice: {
        marginTop: pt(5),
        paddingTop: pt(12),
        paddingBottom: pt(12),
        paddingLeft: pt(15),
        paddingRight: pt(15),
        backgroundColor: 'rgba(255,255,255,1)',
    },
    buy_notice_title: {
        color: 'rgba(26,26,26,1)',
        fontSize: pt(14),
        fontFamily: 'PingFang SC',
        fontWeight: 'bold'
    },
    buy_notice_content: {
        marginTop: pt(10)
    },
    buy_notice_content_txt: {
        fontSize: pt(12),
        color: 'rgb(153,153,153)'
    },
});

export default TicketPurchaseNotice;
